const i18nConfig = {
  defaultLocale: "en",
  locales: [
    "ar",
    "bn",
    "de",
    "en",
    "es",
    "fr",
    "he",
    "id",
    "it",
    "ja",
    "ko",
    "pt",
    "ru",
    "si",
    "sv",
    "te",
    "vi",
    "zh"
  ]
}

module.exports = i18nConfig
